import { HTMLProps, memo, useCallback } from 'react';

import { Button } from 'components';
import { PinIcon } from 'components/Icon';

export type LiveEventPinProps = Pick<HTMLProps<HTMLButtonElement>, 'className' | 'onClick'> & {
  pinned?: boolean;
  currentActiveSpeakerUsername: string | null;
  onPin?(username: string | null): void;
};

const LiveEventPin = ({ className, pinned = false, currentActiveSpeakerUsername, onPin }: LiveEventPinProps) => {
  const handleOnClick = useCallback(() => {
    if (pinned) {
      onPin?.(null);
    } else if (currentActiveSpeakerUsername) {
      onPin?.(currentActiveSpeakerUsername);
    }
  }, [pinned, currentActiveSpeakerUsername, onPin]);

  return (
    <Button className={className} circle="sm" active={pinned} onClick={handleOnClick}>
      <PinIcon width={18} height={18} color={pinned ? 'black' : 'white'} />
    </Button>
  );
};

const memoizedLiveEventPin = memo(LiveEventPin);

export default memoizedLiveEventPin;
